/**
 * kult-b2b-konto.js — „Mein Firmenkonto“ (/pages/firmenkonto, sections/kult-b2b-konto-*.liquid).
 * Lädt einmal GET /apps/seminare/firmenkonto (App-Proxy; Shopify hängt die Kunden-ID an, die App liefert nur Daten der
 * eingeloggten E-Mail) und füllt Kopf, „Auf einen Blick“ und die Blöcke [data-fk-block] (lieferungen, anfragen, angebote,
 * rechnungen, seminare, newsletter). Aktionen als JSON-POST mit X-Requested-With: kult-account (Angebot annehmen nach
 * Bestätigungsdialog, Newsletter an/aus). PDF-Links sind signiert und 10 Minuten gültig: Die Übersicht lädt sich darum alle
 * 8 Minuten (und beim Zurückkehren in den Tab) neu. Daten werden nur per textContent eingesetzt, nie als HTML.
 * Theme-Editor: data-demo="1" → Beispieldaten, keine Anfragen an die App. Texte je Block aus <script data-fk-texts>.
 */
(function () {
  'use strict';
  if (window.__kultB2bKonto) return;
  window.__kultB2bKonto = true;

  var REFRESH_MS = 8 * 60 * 1000;
  var MSG = {
    load: 'Diese Übersicht konnte gerade nicht geladen werden.',
    retry: 'Erneut laden',
    session: 'Ihre Anmeldung ist abgelaufen. Bitte melden Sie sich erneut an.',
    login: 'Anmelden',
    action: 'Das hat gerade nicht geklappt. Bitte versuchen Sie es in einem Moment noch einmal.',
    demo: 'Im Theme-Editor ohne Wirkung (Beispieldaten).',
    datei: {
      abgelaufen: 'Der Download-Link war abgelaufen. Die Übersicht ist aktualisiert, bitte öffnen Sie die Datei noch einmal.',
      ungueltig: 'Diese Datei konnten wir nicht öffnen. Bitte laden Sie die Seite neu oder schreiben Sie uns.',
      'zu-viele': 'Zu viele Downloads in kurzer Zeit. Bitte versuchen Sie es in einer Minute noch einmal.',
      fehler: 'Die Datei ist gerade nicht erreichbar. Bitte versuchen Sie es in einem Moment noch einmal.'
    }
  };

  var DEMO = {
    ok: true, loggedIn: true,
    kunde: { name: 'Maria Muster', email: 'maria.muster@muster-gmbh.de', firma: 'Muster GmbH', firmenkunde: true },
    lieferungen: {
      geplant: [{ titel: 'Bürokaffee laut Angebot AN-2026-00012', angaben: ['Rhythmus: 14-tägig', 'Menge je Monat: 4 kg', 'Kaffee: Beispielsorte'], naechste: 'nach Absprache' }],
      bestellungen: [
        { name: '#1042', datum: '06.10.2026', positionen: ['2 × Beispielsorte (1 kg)', '1 × Beispielsorte (500 g)'], netto: '58,80 €', brutto: '62,92 €', status: 'Versendet', ton: 'ok', sendungen: [{ nummer: '00340434161094042557', url: null, firma: 'DHL' }] },
        { name: '#1031', datum: '22.09.2026', positionen: ['4 × Beispielsorte (1 kg)'], netto: '117,60 €', brutto: '125,83 €', status: 'In Vorbereitung', ton: 'offen', sendungen: [] }
      ]
    },
    anfragen: [
      { datum: '01.10.2026', leistung: 'Bürokaffee', formular: 'Bürokaffee-Konfigurator', firma: 'Muster GmbH', status: 'Angebot erstellt', ton: 'offen', naechsterKontakt: '15.10.2026' },
      { datum: '12.09.2026', leistung: 'Teamevent', formular: null, firma: 'Muster GmbH', status: 'Beauftragt', ton: 'ok', naechsterKontakt: null }
    ],
    angebote: [
      { id: 'demo1', nummer: 'AN-2026-00012', version: 1, datum: '02.10.2026', gueltigBis: '01.11.2026', leistung: 'Bürokaffee', netto: '235,20 €', brutto: '251,66 €', status: 'Offen', ton: 'offen', pdf: '#angebote', annehmbar: true },
      { id: 'demo2', nummer: 'AN-2026-00007', version: 2, datum: '14.09.2026', gueltigBis: '14.10.2026', leistung: 'Team-Event', netto: '480,00 €', brutto: '571,20 €', status: 'Angenommen', ton: 'ok', pdf: '#angebote', annehmbar: false }
    ],
    rechnungen: [
      { nummer: 'RE-2026-00031', art: 'Rechnung', datum: '06.10.2026', bestellung: '#1042', betrag: '62,92 €', netto: '58,80 €', zahlung: 'Bezahlt', ton: 'ok', faellig: null, pdf: '#rechnungen', lieferschein: '#rechnungen' },
      { nummer: 'RE-2026-00024', art: 'Rechnung', datum: '20.09.2026', bestellung: null, betrag: '571,20 €', netto: '480,00 €', zahlung: 'Offen', ton: 'offen', faellig: '04.10.2026', pdf: '#rechnungen', lieferschein: null }
    ],
    seminare: [{ titel: 'Kaffeeseminar klassisch', datum: 'Freitag, 20. November 2026', zeit: '15:00–17:30 · 2,5 Std.', plaetze: 8, status: 'Gebucht', ton: 'ok', kommend: true, url: '#seminare', fehlendeNamen: true }],
    newsletter: { art: 'firmen', state: 'NOT_SUBSCRIBED', seit: null }
  };

  var head = document.querySelector('[data-fk-root]');
  var blocks = Array.prototype.slice.call(document.querySelectorAll('[data-fk-block]'));
  if (!head && !blocks.length) return;
  var endpoint = (head && head.getAttribute('data-endpoint')) || '/apps/seminare/firmenkonto';
  var demo = !!document.querySelector('[data-fk-root][data-demo="1"], [data-fk-block][data-demo="1"]');
  var loadedAt = 0;
  var loading = false;
  var iconTpl = head ? head.querySelector('template[data-fk-icons]') : null;

  /* ---------- Bausteine ---------- */
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null && text !== '') n.textContent = String(text);
    return n;
  }
  function icon(name) {
    var src = iconTpl && iconTpl.content.querySelector('[data-fk-icon="' + name + '"]');
    if (!src) return null;
    var wrap = el('span', 'kult-b2b-link__lead-icon');
    wrap.setAttribute('aria-hidden', 'true');
    wrap.innerHTML = src.innerHTML; // eigenes Theme-Markup (kult-icon), keine Daten
    return wrap;
  }
  function link(href, label, iconName, external) {
    var a = el('a', 'kult-b2b-link kult-b2b-konto__link');
    a.setAttribute('href', href);
    a.setAttribute('data-kult-keep', '');
    if (external && href.charAt(0) !== '#') { a.target = '_blank'; a.rel = 'noopener'; }
    var i = iconName && icon(iconName);
    if (i && iconName === 'arrow') { i.className = 'kult-b2b-link__icon'; a.appendChild(el('span', '', label)); a.appendChild(i); return a; }
    if (i) a.appendChild(i);
    a.appendChild(el('span', '', label));
    return a;
  }
  function texts(block) {
    var t = block.querySelector('script[data-fk-texts]');
    try { return t ? JSON.parse(t.textContent) || {} : {}; } catch (e) { return {}; }
  }
  function status(label, ton) { return el('span', 'kult-b2b-konto__status kult-b2b-konto__status--' + (ton || 'neutral'), label); }

  /** Zeile: title, meta[], details[], status/ton, amount/amountSub, actions[] (Knoten) */
  function row(o) {
    var li = el('li', 'kult-b2b-konto__row');
    var main = el('div', 'kult-b2b-konto__main');
    main.appendChild(el('p', 'kult-b2b-konto__title', o.title));
    var meta = (o.meta || []).filter(Boolean);
    if (meta.length) main.appendChild(el('p', 'kult-b2b-konto__meta', meta.join(' · ')));
    var details = (o.details || []).filter(Boolean);
    if (details.length) {
      var ul = el('ul', 'kult-b2b-konto__details');
      ul.setAttribute('role', 'list');
      details.forEach(function (d) { ul.appendChild(el('li', '', d)); });
      main.appendChild(ul);
    }
    if (o.hint) main.appendChild(el('p', 'kult-b2b-konto__hint', o.hint));
    li.appendChild(main);
    var side = el('div', 'kult-b2b-konto__side');
    if (o.status) side.appendChild(status(o.status, o.ton));
    if (o.amount) {
      var amt = el('p', 'kult-b2b-konto__amount');
      amt.appendChild(el('span', 'kult-b2b-num', o.amount));
      if (o.amountLabel) amt.firstChild.appendChild(el('span', 'kult-b2b-konto__amount-label', o.amountLabel));
      if (o.amountSub) amt.appendChild(el('small', '', o.amountSub));
      side.appendChild(amt);
    }
    li.appendChild(side);
    var actions = (o.actions || []).filter(Boolean);
    if (actions.length) {
      var act = el('div', 'kult-b2b-konto__actions');
      actions.forEach(function (a) { act.appendChild(a); });
      li.appendChild(act);
    }
    return li;
  }
  function list(rows, label) {
    var ul = el('ul', 'kult-b2b-konto__list');
    ul.setAttribute('role', 'list');
    if (label) ul.setAttribute('aria-label', label);
    rows.forEach(function (r) { ul.appendChild(r); });
    return ul;
  }
  function setBody(block, nodes, empty) {
    var body = block.querySelector('[data-fk-body]');
    var emptyEl = block.querySelector('[data-fk-empty]');
    body.innerHTML = '';
    body.removeAttribute('aria-busy');
    (nodes || []).forEach(function (n) { if (n) body.appendChild(n); });
    body.hidden = !!empty;
    if (emptyEl) emptyEl.hidden = !empty;
  }
  function message(block, text, isError) {
    var m = block && block.querySelector('[data-fk-msg]');
    if (!m) return;
    m.textContent = text || '';
    m.hidden = !text;
    m.classList.toggle('kult-b2b-konto__msg--error', !!isError);
  }
  function post(payload) {
    if (demo) return Promise.resolve({ ok: false, data: { error: MSG.demo } });
    return fetch(endpoint, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'kult-account' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) { return { ok: r.ok && j.ok !== false, status: r.status, data: j || {} }; });
    }).catch(function () { return { ok: false, status: 0, data: {} }; });
  }

  /* ---------- Blöcke ---------- */
  var R = {};
  R.lieferungen = function (b, d, t) {
    var L = d.lieferungen || { geplant: [], bestellungen: [] };
    var nodes = [];
    nodes.push(el('h3', 'kult-b2b-h3 kult-b2b-konto__sub', t.planned_title));
    if (L.geplant.length) {
      nodes.push(list(L.geplant.map(function (g) {
        return row({ title: g.titel, details: g.angaben, hint: (t.next_label || 'Nächste Lieferung:') + ' ' + g.naechste });
      })));
    } else nodes.push(el('p', 'kult-b2b-konto__plain', t.planned_none));
    if (L.bestellungen.length) {
      nodes.push(el('h3', 'kult-b2b-h3 kult-b2b-konto__sub', t.orders_title));
      nodes.push(list(L.bestellungen.map(function (o) {
        var actions = (o.sendungen || []).map(function (s) {
          var label = (t.track_label || 'Sendung') + ' ' + (s.firma ? s.firma + ' ' : '') + s.nummer;
          return s.url ? link(s.url, label, 'truck', true) : el('span', 'kult-b2b-konto__plain kult-b2b-konto__tracking', label);
        });
        return row({ title: 'Bestellung ' + o.name, meta: [o.datum], details: o.positionen, status: o.status, ton: o.ton, amount: o.netto, amountLabel: t.net_label || 'netto', amountSub: o.brutto + ' ' + (t.gross_label || 'brutto'), actions: actions });
      })));
      if (t.orders_note) nodes.push(el('p', 'kult-b2b-konto__plain kult-b2b-konto__small', t.orders_note));
    }
    setBody(b, nodes, !L.geplant.length && !L.bestellungen.length);
  };
  R.anfragen = function (b, d, t) {
    var q = d.anfragen || [];
    setBody(b, [list(q.map(function (a) {
      return row({ title: a.leistung, meta: [a.datum, a.formular, a.firma], status: a.status, ton: a.ton, hint: a.naechsterKontakt ? (t.next_label || 'Nächster Kontakt:') + ' ' + a.naechsterKontakt : '' });
    }))], !q.length);
  };
  R.angebote = function (b, d, t) {
    var q = d.angebote || [];
    var mail = b.getAttribute('data-email') || '';
    setBody(b, [list(q.map(function (a) {
      var actions = [];
      if (a.pdf) actions.push(link(a.pdf, t.pdf_label || 'Angebot (PDF)', 'download', true));
      if (a.annehmbar) {
        var btn = el('button', 'kult-b2b-btn kult-b2b-btn--primary kult-b2b-btn--small', t.accept_label || 'Annehmen');
        btn.type = 'button';
        btn.addEventListener('click', function () { accept(b, a, t, btn); });
        actions.push(btn);
      }
      if (mail) actions.push(link('mailto:' + mail + '?subject=' + encodeURIComponent('Rückfrage zu Angebot ' + a.nummer), t.question_label || 'Rückfrage', 'mail'));
      return row({
        title: a.nummer + (a.version > 1 ? ' · Version ' + a.version : ''), meta: [a.leistung, a.datum, a.annehmbar ? (t.valid_label || 'gültig bis') + ' ' + a.gueltigBis : ''],
        status: a.status, ton: a.ton, amount: a.netto, amountLabel: t.net_label || 'netto', amountSub: a.brutto + ' ' + (t.gross_label || 'brutto'), actions: actions
      });
    }))], !q.length);
  };
  R.rechnungen = function (b, d, t) {
    var q = d.rechnungen || [];
    setBody(b, [list(q.map(function (r) {
      var actions = [];
      if (r.pdf) actions.push(link(r.pdf, t.pdf_label || 'Rechnung (PDF)', 'download', true));
      if (r.lieferschein) actions.push(link(r.lieferschein, t.ls_label || 'Lieferschein (PDF)', 'download', true));
      return row({
        title: r.nummer, meta: [r.art !== 'Rechnung' ? r.art : '', r.datum, r.bestellung ? (t.order_label || 'Bestellung') + ' ' + r.bestellung : '', r.faellig ? (t.due_label || 'fällig am') + ' ' + r.faellig : ''],
        status: r.zahlung, ton: r.ton, amount: r.betrag, amountSub: r.netto ? r.netto + ' ' + (t.net_label || 'netto') : '', actions: actions
      });
    }))], !q.length);
  };
  R.seminare = function (b, d, t) {
    var q = d.seminare || [];
    setBody(b, [list(q.map(function (s) {
      var seats = s.plaetze + ' ' + (s.plaetze === 1 ? (t.seats_one || 'Platz') : (t.seats_many || 'Plätze'));
      return row({ title: s.titel, meta: [s.datum, s.zeit, seats], status: s.status, ton: s.ton, hint: s.fehlendeNamen ? t.names_label : '', actions: s.url ? [link(s.url, t.manage_label || 'Buchung verwalten', 'arrow')] : [] });
    }))], !q.length);
  };
  R.newsletter = function (b, d, t) {
    var n = d.newsletter;
    var box = b.querySelector('[data-fk-news]');
    setBody(b, [], !n);
    if (!n || !box) { if (box) box.hidden = true; return; }
    box.hidden = false;
    var sw = box.querySelector('[data-fk-switch]');
    var firmen = n.art === 'firmen';
    box.querySelector('[data-fk-news-label]').textContent = firmen ? t.title_firmen : t.title_zeitung;
    box.querySelector('[data-fk-consent]').textContent = firmen ? t.consent_firmen : t.consent_zeitung;
    function show(state, seit) {
      var on = state === 'SUBSCRIBED' || state === 'PENDING';
      sw.setAttribute('aria-checked', on ? 'true' : 'false');
      var datum = seit ? new Date(seit).toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' }) : 'heute';
      box.querySelector('[data-fk-news-state]').textContent = state === 'SUBSCRIBED' ? String(t.state_on || '').replace('{datum}', datum) : state === 'PENDING' ? t.state_pending : t.state_off;
      n.state = state;
    }
    show(n.state, n.seit);
    sw.disabled = false;
    if (sw.__fk) return;
    sw.__fk = true;
    sw.addEventListener('click', function () {
      var an = sw.getAttribute('aria-checked') !== 'true';
      var consent = box.querySelector('[data-fk-consent]').textContent.replace(/\s+/g, ' ').trim();
      sw.disabled = true;
      post({ intent: 'newsletter', an: an, consentText: consent }).then(function (r) {
        sw.disabled = false;
        if (!r.ok) { message(b, r.data.error || MSG.action, true); return; }
        show(r.data.state || (an ? 'PENDING' : 'UNSUBSCRIBED'), new Date().toISOString());
        message(b, r.data.message || '', false);
      });
    });
  };

  function accept(block, a, t, btn) {
    var dlg = block.querySelector('[data-fk-dialog]');
    var text = String(t.dialog_text || '').replace('{nummer}', a.nummer).replace('{betrag}', a.netto);
    function go() {
      btn.disabled = true;
      post({ intent: 'angebot-annehmen', id: a.id }).then(function (r) {
        btn.disabled = false;
        message(block, r.ok ? r.data.message : (r.data.error || MSG.action), !r.ok);
        if (r.ok) load(true);
      });
    }
    if (!dlg || typeof dlg.showModal !== 'function') { if (window.confirm(text)) go(); return; }
    dlg.querySelector('[data-fk-dialog-text]').textContent = text;
    dlg.returnValue = '';
    dlg.addEventListener('close', function onClose() {
      dlg.removeEventListener('close', onClose);
      if (dlg.returnValue === 'ok') go(); else btn.focus();
    });
    dlg.showModal();
  }

  /* ---------- Laden und Verteilen ---------- */
  function headError(text, withLogin) {
    var e = head && head.querySelector('[data-fk-error]');
    if (!e) return;
    e.textContent = text;
    if (withLogin && head.getAttribute('data-login')) {
      e.appendChild(document.createTextNode(' '));
      var a = el('a', '', MSG.login);
      a.href = head.getAttribute('data-login');
      e.appendChild(a);
    }
    e.hidden = false;
  }
  function render(d) {
    if (head) {
      var f = head.querySelector('[data-fk-firma]');
      if (f && d.kunde && d.kunde.firma) f.textContent = d.kunde.firma;
      var note = head.querySelector('[data-fk-note]');
      if (note && d.kunde) note.hidden = !!d.kunde.firmenkunde;
      var sums = {
        angebote: (d.angebote || []).filter(function (a) { return a.annehmbar; }).length,
        rechnungen: (d.rechnungen || []).filter(function (r) { return r.ton === 'offen'; }).length,
        termine: (d.seminare || []).filter(function (s) { return s.kommend; }).length
      };
      Object.keys(sums).forEach(function (k) { var s = head.querySelector('[data-fk-sum="' + k + '"]'); if (s) s.textContent = String(sums[k]); });
    }
    blocks.forEach(function (b) {
      var kind = b.getAttribute('data-fk-block');
      if (R[kind]) R[kind](b, d, texts(b));
    });
  }
  function fail(text, retry) {
    blocks.forEach(function (b) {
      var p = el('p', 'kult-b2b-konto__plain', text);
      var nodes = [p];
      if (retry) {
        var btn = el('button', 'kult-b2b-btn kult-b2b-btn--outline kult-b2b-btn--small', MSG.retry);
        btn.type = 'button';
        btn.addEventListener('click', function () { load(true); });
        nodes.push(btn);
      }
      setBody(b, nodes, false);
    });
  }
  function load(force) {
    if (loading || (!force && loadedAt && Date.now() - loadedAt < REFRESH_MS)) return;
    if (demo) { loadedAt = Date.now(); render(DEMO); return; }
    loading = true;
    fetch(endpoint, { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { return { status: r.status, data: j || {} }; }); })
      .then(function (res) {
        loading = false;
        if (res.status === 401) { headError(MSG.session, true); fail(MSG.session, false); return; }
        if (res.status !== 200 || !res.data.ok) { headError(res.data.error || MSG.load); fail(MSG.load, true); return; }
        loadedAt = Date.now();
        var e = head && head.querySelector('[data-fk-error]');
        if (e && e.getAttribute('data-fk-datei') !== '1') e.hidden = true;
        render(res.data);
      })
      .catch(function () { loading = false; headError(MSG.load); fail(MSG.load, true); });
  }

  // Pillen zu Blöcken, die auf der Seite fehlen, ausblenden
  if (head) Array.prototype.forEach.call(head.querySelectorAll('[data-fk-jump]'), function (li) {
    var id = li.getAttribute('data-fk-jump');
    if (id && !document.getElementById(id)) li.hidden = true;
  });
  // Rückmeldung aus dem PDF-Abruf (?datei=…)
  try {
    var params = new URLSearchParams(window.location.search);
    var grund = params.get('datei');
    if (grund && MSG.datei[grund]) {
      headError(MSG.datei[grund]);
      var e = head && head.querySelector('[data-fk-error]');
      if (e) e.setAttribute('data-fk-datei', '1');
      params.delete('datei');
      var q = params.toString();
      window.history.replaceState(null, '', window.location.pathname + (q ? '?' + q : '') + window.location.hash);
    }
  } catch (err) { /* ohne URLSearchParams kein Hinweis */ }

  load(true);
  if (!demo) {
    window.setInterval(function () { if (!document.hidden) load(false); }, REFRESH_MS);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) load(false); });
  }
})();
